import { useContext } from 'react'

import { HeadersContext } from '../HeadersContext'

export const useCookieValue = (cookieName: string): string | undefined => {
  const headersContext = useContext(HeadersContext)

  const cookies = headersContext.cookies || ''
  const cookieArray = cookies.split(';').map((cookie) => cookie.trim())
  const cookie = cookieArray.find((cookie) => cookie.startsWith(`${cookieName}=`))

  return cookie ? cookie.split('=')[1] : undefined
}
